<div class="single-date-picker">
    <mat-form-field class="picker start-date" appearance="legacy" floatLabel="never">
        <mat-label>Select Date & Time</mat-label>
        <input #inputBox class="date-field-width date-picker-custom-input" data-input-type="start"
            [formControl]="startFormControl" type="text" readonly="readonly" matInput>
        <mat-icon matSuffix class="date-p-icon">event</mat-icon>
    </mat-form-field>
</div>